import {
	HatchProfileFormData,
	HatchPatternFormData,
	SaveHatchProfileRequest,
	SaveHatchPatternRequest
} from "@/types/hatchProfile";

const mapHatchProfile = (apiData: SaveHatchProfileRequest[]): HatchProfileFormData[] => {
	return apiData.map((profile: SaveHatchProfileRequest): HatchProfileFormData => {
		return {
			id: profile.id,
			name: profile.name,
			description: profile.description,

			hatch_patterns: (profile.hatch_patterns || []).map(
				(pattern: SaveHatchPatternRequest): HatchPatternFormData => ({
					id: pattern.id,

					hatch_type: { value: pattern.hatch_type },

					laser_profile_id: pattern.laser_profile_id ? { value: pattern.laser_profile_id } : null,

					hatch_style: pattern.hatch_style ? { value: pattern.hatch_style } : undefined,

					border_gap: String(pattern.border_gap),
					is_apply_smoothing: !!pattern.is_apply_smoothing,
					with_offset: !!pattern.with_offset,

					border_gap_direction: pattern.border_gap_direction ? { value: pattern.border_gap_direction } : undefined,

					corner_style: pattern.corner_style ? { value: pattern.corner_style } : undefined,

					line_gap: String(pattern.line_gap),
					line_angle: String(pattern.line_angle),

					base_x: String(pattern.base?.x ?? 0),
					base_y: String(pattern.base?.y ?? 0),

					individual_hatch_line_repeat_count: String(pattern.individual_hatch_line_repeat_count),

					is_incremental_rotation_enabled: !!pattern.is_incremental_rotation_enabled,

					incremental_start_angle: String(pattern.incremental_start_angle),
					incremental_step_angle: String(pattern.incremental_step_angle),
					incremental_step_count: String(pattern.incremental_step_count),
				})
			),
		};
	});
};

export default mapHatchProfile;